jQuery(document).ready(function() {
    $('.btn--online-grocery-classifications').click(function () {
        retrieveAndDisplayClassifications(this);
    });
});

function retrieveAndDisplayClassifications(classificationBtn) {
    $('.sub--nav__online-grocery-classifications').empty();
    let $mainMenuTitle = $('.btn--online-grocery-classifications[data-menu-name]').text()
    $.ajax({
        type: "GET",
        url: retrieveClassificationsUrl,
        contentType: 'application/json',
        success: function (responseData) {
            let $divSubMainLinks = $('<div />', {'class': 'nav-left__links'});
            let $listChildUl = $('<ul />', {'class': 'grid-classifications column-count-4 nav-left__links'});
            for(classification of responseData) {
                let $listChildLi = $('<li />', {'class': 'dataLayerBigMenuLevelTwo mn--btns',
                    'data-menu-name': $mainMenuTitle,
                    'data-sub-menu-name': classification.name});
                let $linkChildMainCategory = $('<a />', {'href': baseShopOnlineUrl + classification.url, 'tabindex': 2});
                $linkChildMainCategory.append('<span>'+classification.name+'</span>');
                $listChildLi.append($linkChildMainCategory);
                $listChildUl.append($listChildLi);
            }
            $divSubMainLinks.append($listChildUl);
            $('.sub--nav__online-grocery-classifications').append($divSubMainLinks);
        },
        complete: function () {
          printOutputHeight();
        },
        error: function (jqXHR) {
            TINK.redirectIfConflict(jqXHR);
        }
    });

    function printOutputHeight () {
        if(TINK.matchMediaMobileTablet()) {
            headerMenuAisle.handleNavigationMenu(classificationBtn);
        } else {
            $(classificationBtn).focus();
        }
    }

}